/**
 * TEAM: customs_platform
 *
 * Application theme configuration using Latitude design system colors
 */

import { DefaultTheme } from "styled-components";
import { semanticColors } from "./latitudeTheme";

export const THEME: DefaultTheme = {
  colors: {
    // Primary colors mapped to Latitude design system
    primary: semanticColors.textPrimary,
    secondary: semanticColors.primary,

    // Extended color palette for easier access
    text: {
      primary: semanticColors.textPrimary,
      secondary: semanticColors.textSecondary,
      light: semanticColors.textLight,
      onDark: semanticColors.textOnDark,
    },
    background: {
      primary: semanticColors.backgroundPrimary,
      secondary: semanticColors.backgroundSecondary,
      hover: semanticColors.backgroundHover,
      dark: semanticColors.backgroundDark,
    },
    border: {
      light: semanticColors.borderLight,
      medium: semanticColors.borderMedium,
      dark: semanticColors.borderDark,
    },
    interactive: {
      primary: semanticColors.primary,
      primaryHover: semanticColors.primaryHover,
      primaryLight: semanticColors.primaryLight,
    },
    status: {
      success: semanticColors.success,
      successLight: semanticColors.successLight,
      warning: semanticColors.warning,
      warningLight: semanticColors.warningLight,
      error: semanticColors.error,
      errorLight: semanticColors.errorLight,
      info: semanticColors.info,
    },
  },
};

// https://styled-components.com/docs/api#create-a-declarations-file
declare module "styled-components" {
  export interface DefaultTheme {
    colors: {
      primary: string;
      secondary: string;
      text: {
        primary: string;
        secondary: string;
        light: string;
        onDark: string;
      };
      background: {
        primary: string;
        secondary: string;
        hover: string;
        dark: string;
      };
      border: {
        light: string;
        medium: string;
        dark: string;
      };
      interactive: {
        primary: string;
        primaryHover: string;
        primaryLight: string;
      };
      status: {
        success: string;
        successLight: string;
        warning: string;
        warningLight: string;
        error: string;
        errorLight: string;
        info: string;
      };
    };
  }
}
